require('/opt/odin/app/frontend/components/countdown/index.module.scss');module.exports = "../../app/cells/components/countdown/show.erb";